// @ts-nocheck
import { Overlay } from '@angular/cdk/overlay';
import {
  Component,
  ElementRef,
  EventEmitter,
  HostBinding,
  inject,
  Input,
  OnInit,
  Output,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { formatBytes } from '@lbca-shared/helpers/format-bytes';
import moment from 'moment';
import { v1 as uuidV1 } from 'uuid';
import { waitingTimer } from '../../../../helpers/_old_helpers/animate';
import { USER_SERVICE, UserServiceInterface } from '../../../../services/user.services';
import { LoadingComponent } from '../../../_old_general-components/loading/loading.component';
import { DynamicFormService } from '../../dynamic-form/dynamic-form.service';
import { configurationInterface } from '../../dynamic-form/sub-modules/file-upload/file-upload.component';
import { FileUploadService } from '../../dynamic-form/sub-modules/file-upload/file-upload.service';
import { ErrorOverlayClass } from '../../error-overlay/error-overlay.directive';
import { ModalDirective, ModalInterfaceComunication } from '../../modal-overlay/modal.directive';
import {
  PopupFeedbackDirective,
  PopupInterfaceCommunication,
} from '../../popup-feedback/popup-feedback.directive';
import { TableComponent } from '../../table/table.component';

@Component({
  selector: 'lbca-file-from-process',
  templateUrl: './file-from-process.component.html',
  styleUrl: './file-from-process.component.scss',
  imports: [LoadingComponent, TableComponent],
})
export class FileFromProcessComponent implements OnInit {
  private overlay = inject(Overlay);
  private fileUploadService = inject(FileUploadService);
  private dynamicFormService = inject(DynamicFormService);

  readonly userService = inject<UserServiceInterface>(USER_SERVICE);

  constructor() {
    this.buttonId = uuidV1();
  }

  private modalController = new ModalInterfaceComunication();
  private popupFeedController = new PopupInterfaceCommunication();

  @HostBinding('attr.lbcaControllerModal') lbcaModal = new ModalDirective(
    this.overlay,
    this.modalController
  );

  @HostBinding('attr.lbcaPopupFeedback') popupFeedback = new PopupFeedbackDirective(
    this.overlay,
    this.popupFeedController
  );

  @ViewChild('templateRemove') templateRemove!: TemplateRef<any>;
  @ViewChild('templateRemoveError') templateRemoveError!: TemplateRef<any>;
  @ViewChild('FilesTemplate') templateModal!: TemplateRef<any>;
  @ViewChild('uploadButton', { static: true })
  uploadButton!: ElementRef;
  @ViewChild('name', { static: true }) name!: ElementRef;
  @ViewChild('sizeFeedback', { static: true }) sizeFeedback!: ElementRef;

  loadPage = false;
  loadedFiles = false;
  labelValue = '';
  buttonLabelValue = 'Buscar arquivo';
  fieldValue = '';
  cardInfo: any;
  public flowId!: any;
  public listfiletype!: any;
  processId!: string;
  contextToSearch!: string;
  public fileTypes = {
    doc: 'doc',
    docx: 'doc',
    odt: 'doc',
    jpg: 'jpg',
    jpeg: 'jpg',
    pdf: 'pdf',
    png: 'png',
    ppt: 'ppt',
    xls: 'xls',
    ods: 'xls',
    xlsx: 'xls',
    zip: 'zip',
  };
  public filesList: any[] = [];
  table!: any;
  selectedFile: any;
  currentFile: any;
  isSaving = false;
  public configuration!: configurationInterface;
  hasErrorRequired = false;
  hasError = false;
  public errorRequeridPopup!: any;
  public buttonId!: any;
  public formatBytes = formatBytes;

  @Input('label') set labelSetter(value) {
    this.labelValue = value;
  }
  @Input('buttonLabel') set buttonLabelSetter(value) {
    this.buttonLabelValue = value ? value : 'Buscar arquivo';
  }
  @Input('value') set valueSetter(value) {
    if (value) {
      this.fieldValue = value;
      this.loadPage = false;
      this.getFile();
    }
  }
  @Input()
  set cardData(data: any) {
    this.cardInfo = data;
  }
  @Input('flowId') set flow(id) {
    this.flowId = id;
  }
  @Input('context') set contextSetter(val: string) {
    this.contextToSearch = val;
  }
  @Input('properties') set prop(value) {
    this.configuration = value;
  }
  @Output('saveValue') saveValueEmmiter = new EventEmitter();
  @Output('cloudControl') cloudControlEmitter = new EventEmitter();
  @Output('validateCallback') validateCallbackEmitter = new EventEmitter();

  ngOnInit(): void {
    this.validateCallbackEmitter.emit(this.validateCallbackFields);

    this.table = {
      columns: [
        {
          name: 'fileName',
          label: 'Nome do arquivo',
          type: 'data',
          templateRef: this.name,
          col: 4,
        },
        {
          name: 'uploadDate',
          label: 'Data de upload',
          type: 'data',
          col: 3,
        },
        {
          name: 'user',
          label: 'Usuário',
          type: 'data',
          col: 3,
        },
        {
          name: 'size',
          label: 'Tamanho',
          type: 'data',
          templateRef: this.sizeFeedback,
          col: 2,
        },
      ],
      body: [],
    };

    setTimeout(() => {
      this.loadPage = true;
    }, 2000);

    const { processId } = this.dynamicFormService.formControlStructure?.formMetadata || {};
    this.processId = processId as any;
  }

  public getIcon(type): string {
    const fileType = this.fileTypes[type];
    const icon = fileType
      ? `./assets/icons/files/${fileType}.svg`
      : './assets/icons/files/outros.svg';
    return icon;
  }

  filterDocumentType(value) {
    const listaTipos = value
      ? this.listfiletype.find((labelType) => value === labelType.value)
      : null;
    return listaTipos ? listaTipos.label : `Qual o tipo de documento?`;
  }

  searchFiles() {
    this.modalController.showModal(this.templateModal);
    this.loadedFiles = false;
    this.listFilesType().then((resp) => {
      this.listFiles();
    });
  }

  getFile() {
    this.listFilesType().then((resp) => {
      const FindUsers: string[][] = [];
      const params = {
        processId: this.processId,
        context: this.fieldValue,
        flowId: this.cardInfo.flowId ?? this.flowId,
        taskId: this.dynamicFormService?.taskId,
      };

      const files: any[] = [];
      let finalFiles;
      this.fileUploadService.listFiles(params).subscribe(async (resp) => {
        if (resp?.length > 0) {
          // this.setHasFileEmitter.emit(true);

          resp.forEach(async (file) => {
            const unixValue = file.updatedAt || file.createdAt;
            const lastModified = moment.unix(unixValue).format(moment.defaultFormat);

            const uploadDate =
              file.createdAt && file.createdAt > 0
                ? moment.unix(file.createdAt).format('DD/MM/YYYY')
                : null;
            const id = [file.uploadBy];
            FindUsers.push(id);

            const fileCurrent = {
              origin: file.origin || null,
              bucket: file.bucket || null,
              context: file.context,
              key: file.key,
              id: file.id,
              icon: this.getIcon(file.fileType),
              index: this.filesList.length + 1,
              etag: file.ETag,
              fileName: file.fileName,
              fileType: file.fileType,
              fileId: file.fileId,
              documentType: file.documentType,
              documentTypeName: this.filterDocumentType(file.documentType),
              lastModified: lastModified,
              download: null,
              progress: null,
              size: file.length,
              moduleOrigin: file.moduleOrigin,
              uploadDate: uploadDate ? uploadDate : `-`,
              user: id,
              delete: false,
              confirmDelete: false,
              motionCompleteDataSend: false,
              editLabel: true,
              completeLoad: true,
              error: null,
              typeNotSaved: false,
              savedOk: true,
              validated: file.validated,
              clientView: file.clientView || false,
              sendForBilling: file.sendForBilling || false,
              justify: file.justify,
              observation: file.observation,
              opened: String(file.validated) === 'false' ? true : false,
              notExpandable: String(file.validated) === 'false' ? false : true,
            };

            files.push(fileCurrent);
          });

          finalFiles = [...(await this.userService.returnUserListById(FindUsers, files))];
        }

        if (finalFiles && finalFiles.length > 0) {
          this.currentFile = finalFiles[0];
        }

        this.loadPage = true;
      });
    });
  }

  async listFilesType(): Promise<void> {
    const flowId = this.cardInfo.flowId ?? this.flowId;

    return new Promise((resolve) => {
      this.fileUploadService
        .listFilesType({ flowId, tableName: 'file-types' })
        .subscribe(async (resp) => {
          const listTypes: { value: string; label: string; isVisible: boolean }[] = [];
          resp.forEach((item) => {
            const isVisible = !(item.isVisible === false);
            listTypes.push({ value: item.id, label: item.label, isVisible });
          });
          this.listfiletype = listTypes;
          resolve(resp);
        });
    });
  }

  async listFiles() {
    const FindUsers: string[][] = [];
    const params = {
      processId: this.processId,
      context: this.contextToSearch,
      flowId: this.cardInfo.flowId ?? this.flowId,
      taskId: this.dynamicFormService?.taskId,
    };

    this.fileUploadService.listFiles(params).subscribe(async (resp) => {
      if (resp?.length > 0) {
        // this.setHasFileEmitter.emit(true);

        const files: any[] = [];
        resp.forEach(async (file) => {
          const unixValue = file.updatedAt || file.createdAt;
          const lastModified = moment.unix(unixValue).format(moment.defaultFormat);

          const uploadDate =
            file.createdAt && file.createdAt > 0
              ? moment.unix(file.createdAt).format('DD/MM/YYYY')
              : null;
          const id = [file.uploadBy];
          FindUsers.push(id);

          const fileCurrent = {
            origin: file.origin || null,
            bucket: file.bucket || null,
            context: file.context,
            key: file.key,
            id: file.id,
            icon: this.getIcon(file.fileType),
            index: files.length + 1,
            etag: file.ETag,
            fileName: file.fileName,
            fileType: file.fileType,
            fileId: file.fileId,
            documentType: file.documentType,
            documentTypeName: this.filterDocumentType(file.documentType),
            lastModified: lastModified,
            download: null,
            progress: null,
            size: file.length,
            moduleOrigin: file.moduleOrigin,
            uploadDate: uploadDate ? uploadDate : `-`,
            user: id,
            delete: false,
            confirmDelete: false,
            motionCompleteDataSend: false,
            editLabel: true,
            completeLoad: true,
            error: null,
            typeNotSaved: false,
            savedOk: true,
            validated: file.validated,
            clientView: file.clientView || false,
            sendForBilling: file.sendForBilling || false,
            justify: file.justify,
            observation: file.observation,
            opened: String(file.validated) === 'false' ? true : false,
            notExpandable: String(file.validated) === 'false' ? false : true,
          };

          files.push(fileCurrent);
        });

        this.filesList = files;
        this.table.body = this.filesList;
      }

      this.loadedFiles = true;
    });
  }

  uploadFile(event) {
    this.selectedFile = event;
    this.isSaving = true;
    this.modalController.closeModal();
    const context = this.fieldValue ? this.fieldValue : 'fileUnique_' + uuidV1();

    const params = {
      taskId: this.dynamicFormService?.taskId,
      processId: this.processId,
      context: context,
    };

    const fileSave = {
      fileId: uuidV1(),
      context: context,
      key: event.key,
      fileName: event.fileName,
      s3Name: event.key.split('/')[1],
      metaData: {
        documentType: null,
        fileType: event.fileType,
        length: event.size,
      },
    };

    this.fileUploadService.saveUpload(fileSave, params).subscribe(
      async (success) => {
        this.isSaving = false;
        this.currentFile = JSON.parse(JSON.stringify(this.selectedFile));
        this.selectedFile = null;
        success.entityKey = this.configuration.entityKey;
        this.saveValueEmmiter.emit(success);
        this.currentFile.id = success.id;
        this.currentFile.fileId = success.fileId;
        await waitingTimer(200);
        this.cloudControlEmitter.emit('saved');
      },
      (error) => {
        this.cloudControlEmitter.emit('error');
      }
    );
  }

  public async deleteItem(content): Promise<void> {
    await waitingTimer(20);
    content.remove = !content.remove;
  }

  async confirmDelete(content) {
    this.selectedFile = JSON.parse(JSON.stringify(this.currentFile));
    await waitingTimer(20);

    this.cloudControlEmitter.emit('saving');

    const params = {
      id: content.id,
      taskId: this.dynamicFormService?.taskId,
      processId: this.processId,
      fileId: content.fileId,
    };

    this.isSaving = true;

    this.fileUploadService.deleteFile(params).subscribe(
      async (success) => {
        this.isSaving = false;
        if (success) success.entityKey = this.configuration.entityKey;

        this.cloudControlEmitter.emit('saved');

        this.popupFeedController.autoclose = 2000;
        this.popupFeedController.show(this.templateRemove);

        this.saveValueEmmiter.emit(success);

        this.selectedFile = null;
        this.currentFile = null;
      },
      async (error) => {
        this.popupFeedController.autoclose = 2000;
        this.popupFeedController.show(this.templateRemoveError);

        this.cloudControlEmitter.emit('error');
      }
    );
  }

  public validateCallbackFields = () => {
    let hasError = false;

    if (this.configuration.required && !this.currentFile) {
      hasError = true;
      this.hasErrorRequired = true;
    } else {
      this.hasErrorRequired = false;
    }

    this.hasError = hasError;
    return this.hasError;
  };

  public showErrorRequerid() {
    if (this.hasErrorRequired) {
      this.errorRequeridPopup = new ErrorOverlayClass(this.overlay);
      const component = document.getElementById(this.buttonId);
      this.errorRequeridPopup.setPosition(
        component,
        [
          {
            originX: 'start',
            originY: 'top',
            overlayX: 'start',
            overlayY: 'bottom',
          },
        ],
        0,
        0,
        'bottom',
        'start'
      );

      const errorFeedback = ['É obrigatório anexar arquivos!'];

      this.errorRequeridPopup.setErrors(errorFeedback);
      this.errorRequeridPopup.setFocus(true);
    } else {
      if (this.errorRequeridPopup) {
        this.errorRequeridPopup.setErrors([]);
        this.errorRequeridPopup.setFocus(false);
      }
    }
  }

  public removeErrorRequerid() {
    if (this.errorRequeridPopup) {
      this.errorRequeridPopup.setErrors([]);
      this.errorRequeridPopup.setFocus(false);
    }
  }

  cancel() {
    this.modalController.closeModal();
  }
}
